import request from '../../request';

/** Class representing a Composite client. */
class CompositeClient {
    /** @param {string} compositeInterpsUrl */
    constructor(compositeInterpsUrl) {
        this.compositeInterpsUrl = compositeInterpsUrl;
    }

    getCompositeInterps = () => request.get(this.compositeInterpsUrl);
}

export default CompositeClient;
